import { useRef, useState } from "react";
import { toast } from "sonner";
import { Camera, X, Trash2 } from "lucide-react";
import api, { errMsg } from "@/lib/api";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function ActionPhotos({ r, item, canEdit, onChanged, basePath = "/meeting" }) {
  r = r || item;
  const ref = useRef();
  const [busy, setBusy] = useState(false);
  const [view, setView] = useState(null);
  const upload = async (file) => {
    if (!file) return; setBusy(true);
    try {
      const fd = new FormData(); fd.append("file", file);
      const cap = window.prompt("Caption (optional)") || "";
      if (cap) fd.append("caption", cap);
      await api.post(`${basePath}/${r.id}/photos`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success("Photo added"); onChanged();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); if (ref.current) ref.current.value = ""; }
  };
  const remove = async (pid) => { if (!window.confirm("Remove this photo?")) return; try { await api.delete(`${basePath}/${r.id}/photos/${pid}`); onChanged(); } catch (e) { toast.error(errMsg(e)); } };
  const src = (p) => `${API}${basePath}/${r.id}/photos/${p.id}`;
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={`action-photos-${r.id}`}>
      {r.photos.map((p) => (
        <div key={p.id} className="relative group">
          <img src={src(p)} alt={p.caption || p.original_filename} title={`${p.caption || ""} · ${p.by_name}`} onClick={() => setView(p)} className="h-14 w-14 rounded-md border border-slate-200 object-cover cursor-zoom-in" data-testid={`action-photo-${p.id}`} />
          {canEdit && <button onClick={() => remove(p.id)} className="absolute -top-1.5 -right-1.5 hidden group-hover:flex h-5 w-5 items-center justify-center rounded-full bg-rose-600 text-white" data-testid={`action-photo-delete-${p.id}`}><Trash2 size={10} /></button>}
        </div>
      ))}
      {canEdit && <>
        <input ref={ref} type="file" accept="image/*" capture="environment" className="hidden" onChange={(e) => upload(e.target.files?.[0])} data-testid={`action-photo-input-${r.id}`} />
        <button type="button" disabled={busy} onClick={() => ref.current?.click()} className="flex h-14 w-14 flex-col items-center justify-center gap-0.5 rounded-md border border-dashed border-slate-300 text-[10px] text-slate-500 hover:bg-slate-100" data-testid={`action-photo-add-${r.id}`}><Camera size={16} /> {busy ? "…" : "Photo"}</button>
      </>}
      {view && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/80 p-4" onClick={() => setView(null)}>
          <div className="max-w-4xl max-h-full" onClick={(e) => e.stopPropagation()}>
            <img src={src(view)} alt="" className="max-h-[80vh] rounded-md" />
            <div className="mt-2 flex items-center justify-between text-xs text-white"><span>{view.caption || view.original_filename} · {view.by_name} · {view.at?.slice(0, 16).replace("T", " ")}</span><button onClick={() => setView(null)}><X size={18} /></button></div>
          </div>
        </div>
      )}
    </div>
  );
}
